import { render, staticRenderFns } from "./idolGoodsRefundAudit.vue?vue&type=template&id=0fd21670&scoped=true"
import script from "./idolGoodsRefundAudit.vue?vue&type=script&lang=ts"
export * from "./idolGoodsRefundAudit.vue?vue&type=script&lang=ts"
import style0 from "./idolGoodsRefundAudit.vue?vue&type=style&index=0&id=0fd21670&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd21670",
  null
  
)

export default component.exports